import * as AT from "data/rootActionTypes";

export const getUserList = (state) => state.point[AT.USER_LIST];
export const getIndividualPoint = (state) => state.point[AT.INDIVIDUAL_POINT];
export const getSKUserParticipation = (state) => state.point[AT.SK_USER_PARTICIPATION];

